<template>
  <div>
    <div
      class="form-group variable-selector">
      <grid-row column-align="left" col-spaced>
        <grid-col col-size="1">
          <vue-single-select
            :placeholder="''"
            class="selection-left"
            v-model="symbolOp"
            v-on:input="updateModel"
            :options="operators"
            :hidden="hideOperator"
          />
        </grid-col>
        <grid-col col-size="3" class="center-wrapper">
          <label-input
            type="Number"
            ref="constantValue"
            form-size="m"
            :margin="false"
            :value="constantValue.toString()"
            v-on:input="updateConstantValue"
            required/>
        </grid-col>
      </grid-row>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import BtnPill from '@/components/shared/buttons/BtnPill';
import VueSingleSelect from 'vue-single-select';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import LabelInput from '@/components/shared/forms/LabelInput';

export default {
  name: 'FormulaConstantField',
  components: {
    GridCol,
    GridRow,
    BtnPill,
    vSelect,
    FontAwesomeIcon,
    VueSingleSelect,
    LabelInput
  },
  props: {
    value: {
      type: Object,
      default: () => {
      }
    },
    operators: {
      type: Array,
      default: () => []
    },
    variableOperations: {
      type: Array,
      default: () => []
    },
    hideOperator: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      constantValue: 0,
      symbolOp: null,
      showModal: false
    };
  },
  created () {
    this.updateModel();
  },
  watch: {
    value: {
      handler: function (value) {
        if (this.value == null) {
          return;
        }
        this.constantValue = value.constantValue;
        this.symbolOp = value.symbolOp;
      }
    }
  },
  methods: {
    updateModel () {
      const model = {
        constantValue: this.constantValue,
        symbolOp: this.symbolOp
      };
      this.$emit('input', model);
    },
    updateConstantValue (value) {
      this.constantValue = value;
      this.updateModel();
    }
  }
};
</script>

<style scoped>

.center-wrapper {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/FormulaConstantField.vue